import { useState } from "react";
import {
  Card,
  CardBody,
  CardFooter,
  Col,
  Form,
  Label,
  Row,
  Nav,
  NavItem,
  NavLink,
  CardHeader,
  CardTitle,
  Button,
} from "reactstrap";
import "./styles.css";
import NavItems from "./NavItems";
import { useTranslation } from "react-i18next";
import moment from "moment";

const Alerts = (props: any) => {
  const { t } = useTranslation();
  const { data } = props;

  // Fallback to empty array if applications don't exist yet
  const applications = data?.applications || [];

  // Helper to determine how many days are left
  const getRemainingDays = (expiryDateStr: string) => {
    if (!expiryDateStr) return null;

    // Parse as local date to prevent timezone shifting
    const expiryDate = moment(expiryDateStr, "YYYY-MM-DD").startOf("day");
    const today = moment().startOf("day");

    // Calculate exact difference in days
    return expiryDate.diff(today, "days");
  };

  // Helper to dynamically style background colors based on visa status/urgency
  const getAlertStyle = (status: string, daysLeft: number | null) => {
    const normalizeStatus = status?.toLowerCase();

    if (normalizeStatus === "approved") return "alert-success";
    if (normalizeStatus === "in progress") return "alert-info";
    if (daysLeft !== null && daysLeft < 90) return "alert-warning";

    return "alert-secondary"; // fallback color style
  };

  return (
    <Col lg="3" className="mb-4 mb-lg-0">
      <div className="alerts-section">
        <h6 className="alerts-title">ALERTS</h6>

        {/* Dynamic Loop for Multi-Application Tracking */}
        {applications.map((app: any, index: number) => {
          const daysRemaining = getRemainingDays(app.application_expiry_date);
          const statusValue = app.application_status?.application_status_value || "Pending";
          const alertClass = getAlertStyle(statusValue, daysRemaining);

          return (
            <div key={app.id || index} className={`alert-item ${alertClass} mb-3`}>
              <div className="alert-icon">●</div>
              <div className="alert-content">
                <p className="alert-heading">
                  {app.application_visa_type?.visa_type_value || "Visa"} — {statusValue}
                </p>
                <p className="alert-desc">
                  {app.application_country?.name || "Unknown Country"} (
                  {app.number_of_entries?.number_of_entries_value || "Single Entry"})
                  {daysRemaining !== null && daysRemaining > 0 && ` • ${daysRemaining} days left`}
                </p>
              </div>
            </div>
          );
        })}

        {/* Fallback view if no applications are present in the profile */}
        {applications.length === 0 && (
          <div className="alert-item alert-secondary">
            <div className="alert-icon">●</div>
            <div className="alert-content">
              <p className="alert-heading">No Active Records</p>
              <p className="alert-desc">No applications found for this profile.</p>
            </div>
          </div>
        )}
      </div>
    </Col>
  );
};

export default Alerts;
